/**
 * O avaliador NATIVO das lojas ("Está gostando do LesVita?" + estrelas, sem
 * sair do app): SKStoreReviewController no iOS, In-App Review no Android, via
 * @capawesome/capacitor-app-review.
 *
 * QUANDO PEDIR: num momento bom, não no meio de uma tarefa. O gancho é o FIM
 * da sequência depois de um registro (XP → nível → anúncio → ofensiva →
 * compartilhar → moedas): a pessoa acabou de ser celebrada.
 *   - só no app nativo;
 *   - a partir do 3º registro celebrado neste aparelho;
 *   - no máximo um pedido a cada 60 dias (as lojas ainda limitam por conta
 *     própria: no iOS, 3 aparições por ano, e o SO pode não mostrar nada —
 *     a API não diz se apareceu, por desenho da Apple/Google).
 */

import { Capacitor } from '@capacitor/core';

const CHAVE = 'lesvita:avaliacao-loja';
const REGISTROS_MINIMOS = 3;
const INTERVALO_MS = 60 * 24 * 60 * 60 * 1000;

function ler() {
  try {
    return JSON.parse(localStorage.getItem(CHAVE) || '{}') || {};
  } catch {
    return {};
  }
}

function gravar(v) {
  try {
    localStorage.setItem(CHAVE, JSON.stringify(v));
  } catch {
    /* sem storage: pior caso, pede de novo — a loja segura a frequência */
  }
}

/** Decisão pura (testável). */
export function devePedir({ registros, ultimoPedidoEm, agora }) {
  if ((Number(registros) || 0) < REGISTROS_MINIMOS) return false;
  if (ultimoPedidoEm && agora - ultimoPedidoEm < INTERVALO_MS) return false;
  return true;
}

/**
 * Conta um registro celebrado e, se for a hora, abre o avaliador da loja.
 * Nunca lança e nunca segura o fluxo de quem chamou.
 */
export async function registroCelebrado() {
  if (!Capacitor.isNativePlatform()) return;
  const estado = ler();
  const registros = (Number(estado.registros) || 0) + 1;
  const agora = Date.now();
  const pedir = devePedir({ registros, ultimoPedidoEm: estado.ultimoPedidoEm, agora });
  gravar({ ...estado, registros, ...(pedir ? { ultimoPedidoEm: agora } : {}) });
  if (!pedir) return;
  try {
    const { AppReview } = await import('@capawesome/capacitor-app-review');
    // Um respiro: a tela de quem chamou fecha antes da folha da loja subir.
    setTimeout(() => {
      AppReview.requestReview().catch((e) => console.warn('[avaliacao] requestReview:', e?.message));
    }, 600);
  } catch (e) {
    console.warn('[avaliacao] plugin indisponível:', e?.message);
  }
}
